export default "__VITE_ASSET__C95j7gOL__"